"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _slateReact = require("slate-react");
var _slate = require("slate");
var _reactI18next = require("react-i18next");
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
var _InputChip = _interopRequireDefault(require("../common/InputChip/InputChip"));
var _formatters = require("../../utils/formatters");
var _constants = require("../../utils/constants");
var _StylesGallery = _interopRequireDefault(require("../StylesGallery/StylesGallery"));
var _SlateUtils = require("./SlateUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Element = function Element(_ref) {
  var attributes = _ref.attributes,
    element = _ref.element,
    children = _ref.children,
    setLinksModalOpen = _ref.setLinksModalOpen,
    handleDeleteLink = _ref.handleDeleteLink,
    setCancelList = _ref.setCancelList;
  switch (element.type) {
    case 'bulleted-list':
      setCancelList(false);
      var n = _slate.Node.get(element, [0, 0]);
      return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, attributes, {
        style: {
          color: n.color,
          fontSize: n.size,
          fontFamily: _constants.FONTS[n.font]
        }
      }), children);
    case 'list-item':
      if (children[0].props.text.text === '') {
        setCancelList(true);
      }
      return /*#__PURE__*/_react["default"].createElement("li", attributes, children);
    case 'numbered-list':
      setCancelList(false);
      var n1 = _slate.Node.get(element, [0, 0]);
      return /*#__PURE__*/_react["default"].createElement("ol", _extends({}, attributes, {
        style: {
          color: n1.color,
          fontSize: n1.size,
          fontFamily: _constants.FONTS[n1.font]
        }
      }), children);
    case 'link':
      return /*#__PURE__*/_react["default"].createElement(LinkElement, {
        attributes: attributes,
        element: element,
        children: children,
        setLinksModalOpen: setLinksModalOpen,
        handleDeleteLink: handleDeleteLink
      });
    case 'image':
      return /*#__PURE__*/_react["default"].createElement(ImageElement, {
        attributes: attributes,
        element: element,
        children: children
      });
    default:
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
        style: {
          textAlign: element.align
        }
      }), children);
  }
};
var ImageElement = function ImageElement(_ref2) {
  var attributes = _ref2.attributes,
    children = _ref2.children,
    element = _ref2.element;
  var selected = (0, _slateReact.useSelected)();
  var focused = (0, _slateReact.useFocused)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
    style: {
      textAlign: element.align
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    contentEditable: false
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: element.url,
    style: {
      boxShadow: selected && focused ? '0 0 0 3px #007fff52' : 'none'
    }
  })), children);
};
var LinkElement = function LinkElement(_ref3) {
  var attributes = _ref3.attributes,
    children = _ref3.children,
    element = _ref3.element,
    setLinksModalOpen = _ref3.setLinksModalOpen,
    handleDeleteLink = _ref3.handleDeleteLink;
  var _useTranslation = (0, _reactI18next.useTranslation)('mail-editor'),
    t = _useTranslation.t;
  var refTooltip = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", _extends({}, attributes, {
    href: element.url,
    ref: refTooltip
  }), children), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltip,
    autohide: true,
    trigger: "legacy"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-group-options"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-open"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: validateLink(element.url),
    rel: "noopener noreferrer",
    target: "_blank"
  }, t('openlink'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-change",
    onClick: function onClick() {
      return setLinksModalOpen(element.url, element.children[0].text);
    }
  }, t('change')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-remove",
    onClick: function onClick() {
      return handleDeleteLink(element.url, element.children[0].text);
    }
  }, t('delete')))));
};
var validateLink = function validateLink(url) {
  var defaultProtocol = 'http://';
  var protocol = 'https://';
  return url.includes(defaultProtocol) || url.includes(protocol) ? url : defaultProtocol + url;
};
var Leaf = function Leaf(_ref4) {
  var attributes = _ref4.attributes,
    leaf = _ref4.leaf,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("span", _extends({}, attributes, {
    style: {
      color: leaf.color,
      fontSize: leaf.size,
      fontFamily: _constants.FONTS[leaf.font]
    }
  }), children);
};
var TextEditor = function TextEditor(_ref5) {
  var id = _ref5.id,
    to = _ref5.to,
    from = _ref5.from,
    originalMail = _ref5.originalMail,
    quotedOpen = _ref5.quotedOpen,
    setQuotedOpen = _ref5.setQuotedOpen,
    formatOpen = _ref5.formatOpen,
    _ref5$attachments = _ref5.attachments,
    attachments = _ref5$attachments === void 0 ? [] : _ref5$attachments,
    onDeleteAttachment = _ref5.onDeleteAttachment,
    disabled = _ref5.disabled,
    setLinksModalOpen = _ref5.setLinksModalOpen,
    handleDeleteLink = _ref5.handleDeleteLink;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('mail-editor'),
    t = _useTranslation2.t,
    i18n = _useTranslation2.i18n;
  var editor = (0, _slateReact.useSlate)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    cancelList = _useState2[0],
    setCancelList = _useState2[1];
  var renderElement = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(Element, _extends({}, props, {
      setLinksModalOpen: setLinksModalOpen,
      handleDeleteLink: handleDeleteLink,
      setCancelList: setCancelList
    }));
  }, [setLinksModalOpen, handleDeleteLink]);
  var renderLeaf = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(Leaf, props);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-content"
  }, /*#__PURE__*/_react["default"].createElement(_slateReact.Editable, {
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    spellCheck: true,
    readOnly: disabled,
    onKeyDown: function onKeyDown(event) {
      var auxedit = _objectSpread({}, editor);
      var firstChild = _SlateUtils.UINEditor.getNodeList(auxedit, 'numbered-list') !== undefined ? _SlateUtils.UINEditor.getNodeList(auxedit, 'numbered-list') : _SlateUtils.UINEditor.getNodeList(auxedit, 'bulleted-list');
      if (event.key === 'Backspace' && (_slate.Node.get(auxedit, [firstChild ? firstChild : 0]).type === 'bulleted-list' || _slate.Node.get(auxedit, [firstChild ? firstChild : 0]).type === 'numbered-list') && (_slate.Node.get(auxedit, [firstChild, 0, 0]).text === '' || cancelList)) {
        event.preventDefault();
        if (!_slateReact.ReactEditor.isFocused(editor)) _slateReact.ReactEditor.focus(editor);
        _SlateUtils.UINEditor.toggleType(editor, _slate.Node.get(auxedit, [firstChild]).type);
        setCancelList(false);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-toggle-quote-wrap"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    id: 'uin-med-toggle-quote-' + id,
    className: "uin-med-quoted-btn",
    onClick: function onClick() {
      return setQuotedOpen(!quotedOpen);
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon more-left"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-med-quote' + (quotedOpen ? ' show' : ''),
    contentEditable: true,
    suppressContentEditableWarning: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-quote-details"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "".concat(t('from'), ": ").concat(to.name, " <").concat(to.account, ">")), /*#__PURE__*/_react["default"].createElement("p", null, t('sent'), ": ", (0, _formatters.formatMailDate)(originalMail.date, i18n.language.slice(0, 2))), /*#__PURE__*/_react["default"].createElement("p", null, t('to'), ": ", from.name, from.account ? " <".concat(from.account, ">") : ''), /*#__PURE__*/_react["default"].createElement("p", null, t('subject'), ": ", originalMail.subject)), /*#__PURE__*/_react["default"].createElement("blockquote", null, (0, _reactHtmlParser["default"])(originalMail.content)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-attachments"
  }, attachments.map(function (a, i) {
    if (!a.IsInline) return /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
      key: i,
      color: "blue",
      label: a.name,
      errorMessage: a.unsafeType ? t('unsafe-file') : a.invalidSize ? t('invalid-size') : undefined,
      onDelete: function onDelete() {
        return onDeleteAttachment(a, i);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
    isOpen: formatOpen,
    className: "uin-med-format"
  }, /*#__PURE__*/_react["default"].createElement(_StylesGallery["default"], {
    id: id
  })));
};
var _default = exports["default"] = TextEditor;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MailEditor/TextEditor.js
// module id = 1414
// module chunks = 0